import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopStrip } from './TopStrip';
import { CommandPalette } from './CommandPalette';

interface AppShellProps {
  children:  React.ReactNode;
  userEmail: string | null;
  onSignOut: () => void;
}

/** Full-height layout: sidebar, system strip, page content, command palette. */
export const AppShell: React.FC<AppShellProps> = ({ children, userEmail, onSignOut }) => {
  const [paletteOpen, setPaletteOpen] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setPaletteOpen(v => !v);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="flex h-screen w-full bg-white overflow-hidden">
      <Sidebar userEmail={userEmail} onSignOut={onSignOut} />
      <main className="flex-1 overflow-y-auto">
        <TopStrip onOpenPalette={() => setPaletteOpen(true)} />
        <div className="max-w-[1440px] mx-auto px-8 pt-8 pb-16">
          {children}
        </div>
      </main>
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
    </div>
  );
};
